<template>
  <div>
    <div
      :class="[
        selected ? 'selected' : '',
        noBorder ? '' : 'card card_white flex-fill',
      ]"
      style="margin-bottom: 12px; cursor: pointer"
      v-bind:style="height != null ? 'height: ' + height + 'px;' : ''"
    >
      <div class="sub_title_2">
        <span v-if="param.metricName != null">{{ param.metricName }}</span>
      </div>
      <div v-if="param.value != null" class="data_text">
        {{ formattedNumber(param.value) }}
        <span class="data_text_unit">{{ param.unit }}</span>
      </div>
      <div class="d-flex mt-2">
        <div
          @mouseenter="showTooltipArc"
          @mouseleave="hideTooltipArc"
          v-if="achievement === true"
          class="d-inline-flex align-items-center me-2 tooltip-container"
          :class="
            param.achievementStatus === 'UP'
              ? 'badge_green'
              : param.achievementStatus === 'DOWN'
              ? 'badge_red'
              : 'badge_black'
          "
        >
          <div v-if="visibleArc" class="tooltip-content">
            <span>Achievement</span>
          </div>
          <IconSvg
            :color="param.achievementStatus === 'UP' ? 'green' : 'red'"
            :type="param.achievementStatus === 'UP' ? 'arrow_up' : 'arrow_down'"
          />
          <div
            class="data_detil"
            v-bind:style="
              param.achievementStatus === 'UP'
                ? 'color: green;'
                : param.achievementStatus === 'DOWN'
                ? 'color: red;'
                : 'color: black;'
            "
          >
            {{ param.achievement != null ? param.achievement : "-" }}
          </div>
        </div>
        <div
          @mouseenter="showTooltip"
          @mouseleave="hideTooltip"
          v-if="trend === true"
          class="d-inline-flex align-items-center tooltip-container"
          :class="
            param.trendStatus === 'UP'
              ? 'badge_green'
              : param.trendStatus === 'DOWN'
              ? 'badge_red'
              : 'badge_black'
          "
        >
          <div
            style="left: 60px !important"
            v-if="visible"
            class="tooltip-content"
          >
            <span>Trend</span>
          </div>
          <IconSvg
            :color="param.trendStatus === 'UP' ? 'green' : 'red'"
            :type="param.trendStatus === 'UP' ? 'chart_up' : 'chart_down'"
          />
          <div
            class="data_detil"
            v-bind:style="
              param.trendStatus === 'UP'
                ? 'color: green;'
                : param.trendStatus === 'DOWN'
                ? 'color: red;'
                : 'color: black;'
            "
          >
            {{ param.trend != null ? param.trend : "-" }}
          </div>
        </div>
      </div>
      <!-- <div class="sub_title_2">
        <span>({{ param.freqOfUpdate }})</span>
      </div> -->
      <div v-if="chart" style="position: absolute; bottom: 15px; right: 15px">
        <img
          @click="showGraph"
          @mouseover="hover"
          @mouseleave="afterHover"
          :class="{ hovered: isHovered }"
          class="naked_button"
          style="cursor: pointer"
          :src="imgDetail"
        />
        <!-- <button
          @mouseover="hover"
          @mouseleave="afterHover"
          :class="{ hovered: isHovered }"
          class="naked_button"
          @click="showGraph"
        >
          <img :src="imgDetail" />
        </button> -->
      </div>
      <div
        v-if="
          param.metricId === 'EQUIVALENT_AVAILABILITY_FACTOR' ||
          param.metricId === 'SUDDEN_OUTAGE_FACTOR' ||
          param.metricId === 'EQUIVALENT_FORCE_OUTAGE_FACTOR'
        "
        class="d-inline-flex align-items-center me-2"
      >
        <div style="color: #7a7a7a; font-size: small">Angka Estimasi</div>
      </div>
      <div class="d-inline-flex align-items-center me-2">
        <div style="color: #7a7a7a; font-size: small">{{ titleOpt }}</div>
      </div>
      <div class="d-inline-flex align-items-center me-2">
        <div style="color: #7a7a7a; font-size: small">
          Period: {{ convertToMMMYYYY(param.month, param.year) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import IconSvg from "@/components/IconSvg.vue";
import { formattedNumber } from "@/utils/helper";

export default {
  components: {
    IconSvg,
  },
  data() {
    return {
      visible: false,
      visibleArc: false,
      isHovered: false,
      imgDetail: require("@/assets/images/a/chart_icon.svg"),
    };
  },
  props: {
    param: {
      type: Object,
      required: true,
    },
    height: {
      type: Number,
      required: false,
    },
    noBorder: {
      type: Boolean,
      required: false,
    },
    selected: {
      type: Boolean,
      required: false,
    },
    achievement: {
      type: Boolean,
      required: false,
    },
    trend: {
      type: Boolean,
      required: false,
    },
    chart: {
      type: Boolean,
      required: false,
    },
    titleOpt: {
      type: String,
      required: false,
    },
  },

  mounted() {},
  watch: {
    selected: function (newVal, oldVal) {
      // watch it
    },
  },

  methods: {
    convertToMMMYYYY(month, year) {
      if (month !== null) {
        return moment(`${month}, ${year}`, "M, YYYY").format("MMM, YYYY");
      } else {
        return "-";
      }
    },
    showTooltip() {
      this.visible = true;
    },
    hideTooltip() {
      this.visible = false;
    },
    showTooltipArc() {
      this.visibleArc = true;
    },
    hideTooltipArc() {
      this.visibleArc = false;
    },
    hover() {
      this.isHovered = true;
      this.imgDetail = require("@/assets/images/a/chart_icon_active.svg");
    },
    afterHover() {
      this.imgDetail = require("@/assets/images/a/chart_icon.svg");
    },
    showGraph() {
      this.$emit("showGraph");
    },
    formattedNumber,
  },
};
</script>
<style scoped>
.selected {
  background-color: #ecf9ff;
  border: 1px solid #00a3e9;
}
.hovered {
  transform: scale(1.1); /* Example of hover effect */
  /* Add any other styles you want to apply on hover */
}
</style>
